export enum GenderType {
  Male = "male",
  Female = "female",
}
export enum OnboardingStep {
  Name = "name",
  Email = "email",
  Height = "height",
  Gender = "gender",
}

export enum MuseScreenStep {
  Body = "body",
  Face = "face",
  SizeFit = "sizeFit",
  Ready = "ready",
}



export enum SectionType {
  Full = "full",
  Body = "body",
  Face = "face",
}

export enum FaceScanErrorType {
  Camera = "camera",
  Scan = "scan",
}

export enum PreferredLanguage {
  English = "English",
  Hindi = "Hindi",
  German = "German",
  French = "French",
  Spanish = "Spanish",
  Arabic = "Arabic",
  Italian = "Italian",
}
